import { Page } from "v2/components";

import { ActivitySetup } from "../shared/ActivitySetup";
import { ConnectorSetup } from "../shared/ConnectorSetup";
import { ContractDataSetup } from "../shared/ContractDataSetup";

import { useEffect, useState } from "react";
import { ICategory, ITemplate } from "../shared/ActivitySetup/types";
import { useQuery } from "@tanstack/react-query";
import api from "services/api";
import { IContractData } from "../shared/ContractDataSetup/types";
import { useHistory, useParams } from "react-router-dom";
import { useAuth } from "contexts/auth";
import { Header, Subheader, Title, Typography } from "./styled";
import {
  Autocomplete,
  Avatar,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { LayoutSetup } from "../shared/LayoutSetup";
import { useAlert } from "contexts/alert";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { BenefitsPolicy, Rules } from "v2/pages/SetupContract/Health";
import { SetupContext } from "v2/pages/SetupContract/Health/Setup.context";
import { ISetup } from "v2/pages/SetupContract/Health/Setup.types";

import { Rules as RulesLife, BenefitsPolicy as BenefitsPolicyLife, CapitalInsured } from "v2/pages/SetupContract/Life";
import { SetupContext as LifeSetupContext } from "v2/pages/SetupContract/Life/SetupLife.context";
import { ISetup as ILifeSetup } from "v2/pages/SetupContract/Life/SetupLife.types";

export interface ISupplierProducts {
  link: string;
  buyer: {
    federalTaxId: string;
    corporateName: string;
  };
  supplierProducts: {
    corporateName: string;
    products: {
      id: string;
      name: string;
      productType: "HEALTH" | "DENTAL" | "LIFE";
    }[];
  }[];
}

export interface IConnector {
  id: string;
  name: string;
  isExpired: boolean;
}

export interface ILayout {
  id: string;
  formats: string[];
  productType: string;
  isConfigured: boolean;
  selectedFormats: string[]; //ID DOS FORMATOS EFETIVAMENTE SELECIONADOS
}

export interface ILayoutSupplier {
  name: string;
  layouts: ILayout[];
}

function maskCNPJ(cnpj: string): string {
  // Remove tudo que não for dígito
  const digits = cnpj.replace(/\D/g, "");

  // Aplica a máscara: 00.000.000/0000-00
  return digits
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2")
    .slice(0, 18); // Garante que não passe do tamanho do CNPJ
}

function getInitials(corporateName: string) {
  const firstLetter = corporateName
    ?.split(" ")?.[0]
    ?.split("")?.[0]
    ?.toUpperCase();
  const secondLetter = corporateName
    ?.split(" ")?.[1]
    ?.split("")?.[0]
    ?.toUpperCase();

  if (!firstLetter && !secondLetter) return "AB";

  if (!secondLetter) return firstLetter;

  if (!firstLetter) return secondLetter;

  return `${firstLetter}${secondLetter}`;
}

export function CreateWorkspaces() {
  const { buyerId } = useParams() as { buyerId: string };
  const user = useAuth();
  const history = useHistory();
  const { openAlert } = useAlert();

  /**
   * DADOS DO WORKSPACE BASE (produto selecionado, etc.)
   */
  const [canChange, setCanChange] = useState(false);
  const [workspaceId, setWorkspaceId] = useState<string | null>(null);
  const [isCreating, setIsCreating] = useState(false);
  const [productData, setProductData] = useState({
    product: {
      id: "",
      name: "",
    },
    supplier: {
      id: "",
      name: "",
    },
    buyerId,
    sellerId: user.user?.organization?.cnpj ?? "", //mudar para userId depois - pode ser assumido no back tbm
  });

  // const sellerTesteCnpj = "98337642000185";

  const {
    data: products,
    isFetching: isFetchingProduct,
    isError: isErrorProduct,
  } = useQuery({
    queryKey: ["products", buyerId],
    // queryFn: () => api.get(`/v2/products/${sellerTesteCnpj}/${buyerId}`),
    queryFn: () =>
      api.get(`/v2/products/${user.user?.organization?.cnpj}/${buyerId}`),
    select: (data) => data.data.data as ISupplierProducts,
  });

  /**
   * DADOS DO CONTRATO
   * Criação = cria o objeto aqui
   * Edicao = busca os dados da API
   */
  const [contractData, setContractData] = useState<IContractData>({
    cadastro: {
      cliente: "",
      cnpj: "",
      operadora: "",
      nomeDoProduto: "",
      tipoOperadora: "",
      nContratoApolice: "",
      valorProdutoIOF: "",
      modoDeContratacao: "",
      nVidasInicial: "",
      vigencia: "",
      dataInicioVigencia: "",
      periodoAvisoPrevio: "",
      enderecoFatura: "",
    },
    cobranca: {
      aposentadoCobradoDireto: "",
    },
    faturamento: {
      tipoFatura: "",
      tipoCobranca: "",
      formaPagamento: "",
    },
    operacao: {
      regraMovimentacao: "",
      inicioVigencia: "",
      vencimentoPremio: "",
      emissaoFatura: "",
      tipoDataExclusao: "DISMISSAL_DATE",
    },
    elegibilidade: {
      planos: {
        coparticipacao: "",
        tipoCobertura: "",
        abrangenciaGeografica: "",
      },
      elegibilidade: {
        contribuicao: "",
        contribuicaoTitular: "",
        contribuicaoDependente: "",
        limiteTecnico: "",
        periodoRemissao: "",
        valorTaxa: "",
      },
      caracteristicas: [],
      // caracteristicas: [{ plano: "", codigo: "", valor: "", cargos: "" }, { plano: "", codigo: "", valor: "", cargos: "" }],
      tipo: [],
      // tipo: [{ tipo: "", regra: "", subGrupo: "" }],
    },
    reajusteContrato: {
      inicioAnalise: "",
      fimAnalise: "",
      dataProgramada: "",
      mesReajuste: "",
      periodoAplicacao: "",
      premioAntes: "",
      reajuste: "",
      tipoReajuste: "",
    },
  });

  function handleEditContractData(payload: Partial<typeof contractData>) {
    setContractData((prev) => ({ ...prev, ...payload }));
  }

  useEffect(() => {
    if (products) {
      //client: buyer.corporateName
      //cnpj: buyer.federalTaxId,
      setContractData({
        ...contractData,
        cadastro: {
          ...contractData.cadastro,
          cliente: products.buyer.corporateName,
          cnpj: products.buyer.federalTaxId,
          nomeDoProduto: productData.product.name,
          operadora: productData.supplier.name,
        },
      });
    }
  }, [products, productData]);

  /**
   * TEMPLATES/CATEGORIES -> CONFIG DE ACTIVITIES
   */
  const [categories, setCategories] = useState<null | ICategory[]>(null);

  const {
    data: templatesData,
    isFetching: isFetchingTemplates,
    isFetched: isFetchedTemplates,
    isError: isErrorTemplates,
  } = useQuery({
    queryKey: ["templates"],
    queryFn: () => api.get(`/v2/templates`),
    select: (data) => data.data.data as ICategory[],
  });

  useEffect(() => {
    if (isFetchedTemplates && templatesData) {
      console.log(
        "🆕 CREATE WORKSPACE: Templates carregados (dados limpos)",
        templatesData
      );
      setCategories(templatesData);
    }
  }, [templatesData]);

  function handleUpdateCategories(payload: ITemplate) {
    if (!categories) return;

    const payloadCategory = categories.find((category) =>
      category.templates.find((template) => template.name === payload.name)
    );

    if (!payloadCategory) return;

    const newPayloadCategory = {
      ...payloadCategory,
      templates: payloadCategory.templates.map((template) => {
        if (template.name === payload.name) {
          return { ...payload };
        }
        return { ...template };
      }),
    };

    const newCategories = categories.map((category) => {
      if (category.name === payloadCategory.name) {
        return { ...newPayloadCategory };
      }
      return { ...category };
    });

    setCategories((prev) => [...newCategories]);
  }

  /**
   * CONNECTORS
   */
  // const organizationId = "85dc5dfe-afff-4d3f-a4fd-6cfb8c956ac3"; // USADO PARA BUSCAR OS CONNECTORES DA CONTA ATUAL
  const organizationId = user.user?.organization?.cnpj;
  const {
    data: connectors,
    isFetching: isConnectorsFetching,
    isFetched: isConnectorsFetched,
    isError: isConnectorsError,
  } = useQuery({
    queryKey: ["connectors"],
    queryFn: () => api.get(`/v2/organizations/${organizationId}/connectors`),
    select: (data) => data.data.data as IConnector[],
  });

  //Connectores usados nas activities
  const selectedConnectors: string[] = [];
  categories?.forEach((category) => {
    category.templates.forEach((template) => {
      template.activities.forEach((activity) => {
        activity.connectors.forEach((conn) => {
          /** SO PODE FAZER ISSO COM OS QUE O TEMPLATE.ISCONFIGURED = TRUE */
          if (template.isConfigured) selectedConnectors.push(conn.name);
        });
      });
    });
  });

  /**
   * LAYOUTS
   */
  const [layoutsGlobal, setLayouts] = useState<null | ILayoutSupplier[]>(null);
  const [allowedLayouts, setAllowedLayouts] = useState<
    { title: string; id: string }[]
  >([]);
  const {
    data: layoutsData,
    isFetching: isFetchingLayouts,
    isFetched: isFetchedLayouts,
    isError: isErrorLayouts,
  } = useQuery({
    queryKey: ["layouts"],
    queryFn: () => api.get(`/v2/layouts`),
    select: (data) => data.data.data as ILayoutSupplier[],
  });

  useEffect(() => {
    if (isFetchedLayouts && layoutsData) {
      setLayouts(layoutsData);
    }
  }, [layoutsData]);

  // FUNCAO SO PRA ATUALIZAR UI AQUI MESMO PRA ACTIVE
  function handleUpdateLayouts(
    payload: ILayout,
    allowed: { title: string; id: string }
  ) {
    if (!layoutsGlobal) return;

    const newLayouts = layoutsGlobal.map((l) => ({
      ...l,
      layouts: l.layouts.map((lay) => ({
        ...lay,
        ...(lay.id === payload.id && { isConfigured: true }),
      })),
    }));

    setLayouts(newLayouts);
    setAllowedLayouts((prev) => [...prev, allowed]);
  }

  const [setup, setSetup] = useState<ISetup>({
    rules: {
      rulesRegister: {},
      rulesCharge: {},
      rulesInvoicing: {},
      rulesOperation: {
        inclusion: {
          rule: "IMEDIATA",
          configImmediate: {},
          configMonthly: {},
          configScheduled: {},
        },
        exclusion: {
          rule: "IMEDIATA",
          exclusionDateType: "DISMISSAL_DATE",
          configImmediate: {},
          configMonthly: {},
          configScheduled: {},
        },
        transference: { mandatoryDocuments: [] },
        change: [],
      },
      rulesElegibility: { elegibilityRules: [], plans: [] },
      rulesReadjustment: {},
    },
    benefitsPolicy: {
      type: "ROLE",
      benefitsPolicyByUnique: {},
      benefitsPolicyByGeographicRegion: [],
      benefitsPolicyByRole: [],
    },
  });
  useEffect(() => {
    if (products) {
      const newProduct = {
        buyerOrganizationName: products?.buyer?.corporateName ?? undefined,
        buyerFederalTaxId: products?.buyer?.federalTaxId ?? undefined,
        productName: productData?.product?.name ?? undefined,
        supplierOrganizationName: productData?.supplier?.name,
      };

      setSetup({
        ...setup,
        rules: {
          ...setup.rules,
          rulesRegister: { ...setup.rules.rulesRegister, ...newProduct },
        },
      });
    }
  }, [products, productData]);
  async function handleSavePolicyAndRules(payload: ISetup) {
    if (!workspaceId) return;

    try {
      await api.post("/v2/new/workspaces/create", {
        setup: payload,
        context: { workspaceId },
      });

      setSetup(payload);
      openAlert("Dados salvos com sucesso.", "success");
    } catch (error) {
      openAlert("Algo deu errado ao salvar os dados", "error");
    }
  }
  const [lifeSetup, setLifeSetup] = useState<ILifeSetup>({
    rules: {
      rulesRegister: {},
      rulesCharge: {},
      rulesInvoicing: {},
      rulesOperation: {},
      rulesCost: {},
      rulesReadjustment: {},
    },
    benefitsPolicy: {
      negotiations: [],
      type: "ROLE",
      benefitsPolicyByUnique: {},
      benefitsPolicyByGeographicRegion: [],
      benefitsPolicyByRole: [],
    },
    capitalInsured: []
  });
  useEffect(() => {
    if (products) {
      const newProduct = {
        buyerOrganizationName: products?.buyer?.corporateName ?? undefined,
        buyerFederalTaxId: products?.buyer?.federalTaxId ?? undefined,
        productName: productData?.product?.name ?? undefined,
        supplierOrganizationName: productData?.supplier?.name,
      };

      setLifeSetup({
        ...lifeSetup,
        rules: {
          ...lifeSetup.rules,
          rulesRegister: { ...lifeSetup.rules.rulesRegister, ...newProduct },
        },
      });
    }
  }, [products, productData]);
  async function handleSavePolicyAndRulesLife(payload: ILifeSetup) {
    if (!workspaceId) return;

    try {
      await api.post("/v2/new/workspaces/create", {
        setup: payload,
        context: { workspaceId },
      });

      setLifeSetup(payload);
      openAlert("Dados salvos com sucesso.", "success");
    } catch (error) {
      openAlert("Algo deu errado ao salvar os dados", "error");
    }
  }

  async function handleCreateWorkspace() {
    setIsCreating(true);

    try {
      const isLife = productData.product.name === "Vida";

      const response = await api.post("/v2/new/workspaces/create", {
        setup: isLife ? lifeSetup : setup,
        context: {
          buyerId: buyerId,
          sellerId: user.user?.organization?.cnpj ?? "",
          supplier: {
            supplierName: productData.supplier.name,
            productName: productData.product.name,
          },
        },
      });

      setWorkspaceId(response.data.data.workspaceId);
      setCanChange(true);
    } catch (error) {
      openAlert("Não foi possível criar o contrato.", "error");
    } finally {
      setIsCreating(false);
    }
  }

  /**
   * On create:
   * - Cria o objeto normalmente com a estrutura de dados
   * - Salva na API nova que guarda os dados em uma nova coluna/tabela
   *
   * On edit:
   * - Busca os dados da API e pega da nova tabela para Política e regras de movimentação
   * - Salva na mesma API que guarda os dados em uma nova coluna/tabela
   */

  return (
    <>
      {isFetchingProduct && <div>Loading...</div>}
      {isErrorProduct && <div>Error...</div>}
      {products && (
        <>
          {!canChange && (
            <Page title="Adicionar um contrato" backRoute={products.link}>
              <Page.Tab name="Selecionar um produto">
                <>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Title>
                      Preencha os campos para configurar um novo contrato
                    </Title>
                    <Typography>
                      Por favor, selecione a operadora e o produto.
                    </Typography>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      minHeight: "500px",
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        maxWidth: "530px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        // justifyContent: "center",
                        gap: "24px",
                        paddingTop: "100px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "8px",
                          marginBottom: "10px",
                        }}
                      >
                        <Avatar
                          alt="Avatar"
                          variant="circular"
                          style={{ width: "40px" }}
                        >
                          {getInitials(products.buyer.corporateName)}
                        </Avatar>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <Header>{products.buyer.corporateName}</Header>
                          <Subheader>
                            {maskCNPJ(products.buyer.federalTaxId)}
                          </Subheader>
                        </div>
                      </div>
                      {/* <Autocomplete
                        disablePortal
                        fullWidth
                        id="combo-box-demo"
                        value={"Teste 1"}
                        options={["Teste 1", "Teste 2"]}
                        onChange={(e, v) => console.log(v)}
                        renderInput={(params) => <TextField {...params} label="Movie" />}
                      /> */}
                      <FormControl fullWidth>
                        <InputLabel id="operadora">Operadora</InputLabel>
                        <Select
                          labelId="operadora"
                          value={productData.supplier.name}
                          onChange={(e) =>
                            setProductData({
                              ...productData,
                              supplier: {
                                ...productData.supplier,
                                name: e.target.value,
                              },
                            })
                          }
                        >
                          {products.supplierProducts.map((supplierProducts) => (
                            <MenuItem
                              key={supplierProducts.corporateName}
                              value={supplierProducts.corporateName}
                            >
                              {supplierProducts.corporateName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="produto">Produto</InputLabel>
                        <Select
                          labelId="produto"
                          value={productData.product.name}
                          onChange={(e) =>
                            setProductData((prev) => ({
                              ...prev,
                              product: {
                                ...productData.product,
                                name: e.target.value,
                              },
                            }))
                          }
                        >
                          {products.supplierProducts
                            .find(
                              (o) =>
                                o.corporateName === productData.supplier.name
                            )
                            ?.products?.map((product) => (
                              <MenuItem key={product.name} value={product.name}>
                                {product.name}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-end",
                          gap: "8px",
                          marginTop: "190px",
                        }}
                      >
                        {/* <Button
                          variant="outlined"
                          // color="error"
                          style={{
                            paddingTop: "0.25rem",
                            paddingBottom: "0.25rem",
                            paddingLeft: "1rem",
                            paddingRight: "1rem",
                            borderRadius: "0.375rem",
                            height: "2.5rem",
                            fontSize: "0.875rem",
                            lineHeight: "1.25rem",
                            fontWeight: 600,
                            width: "130px",
                          }}
                          // onClick={() => setSelectedLayout(null)}
                        >
                          Voltar
                        </Button> */}
                        <Button
                          variant="outlined"
                          style={{
                            paddingTop: "0.25rem",
                            paddingBottom: "0.25rem",
                            paddingLeft: "1rem",
                            paddingRight: "1rem",
                            borderRadius: "0.375rem",
                            height: "2.5rem",
                            fontSize: "0.875rem",
                            lineHeight: "1.25rem",
                            fontWeight: 600,
                            width: "130px",
                          }}
                          startIcon={
                            <ChevronLeftIcon
                              color="primary"
                              style={{ height: "22px", marginLeft: "-8px" }}
                            />
                          }
                          onClick={() => history.push(products.link)}
                        >
                          Voltar
                        </Button>
                        <Button
                          variant="contained"
                          style={{
                            paddingTop: "0.25rem",
                            paddingBottom: "0.25rem",
                            paddingLeft: "1rem",
                            paddingRight: "1rem",
                            borderRadius: "0.375rem",
                            height: "2.5rem",
                            fontSize: "0.875rem",
                            lineHeight: "1.25rem",
                            fontWeight: 600,
                            width: "130px",
                          }}
                          disabled={
                            !productData.product.name ||
                            !productData.supplier.name ||
                            isCreating
                          }
                          onClick={handleCreateWorkspace}
                        >
                          Adicionar
                        </Button>
                      </div>
                    </div>
                  </div>
                </>
              </Page.Tab>
            </Page>
          )}
          {canChange && productData?.product?.name !== "Vida" && (
            <SetupContext.Provider
              value={{ setup: setup, updateSetup: handleSavePolicyAndRules }}
            >
              <Page title="Adicionar um contrato" backRoute={products.link}>
                <Page.Tab name="Dados do contrato">
                  <Rules />
                </Page.Tab>
                {/* <Page.Tab name="Dados do contrato">
                  <ContractDataSetup workspace={{ buyerId: productData.buyerId, productId: productData.product.name, sellerId: productData.sellerId, supplierId: productData.supplier.name }} contractData={contractData} handleEdit={handleEditContractData} />
                </Page.Tab> */}
                <Page.Tab name="Políticas do beneficio">
                  <BenefitsPolicy />
                </Page.Tab>
                <Page.Tab name="Atividades">
                  <>
                    {!isFetchedTemplates && isFetchingTemplates && (
                      <div>Loading...</div>
                    )}
                    {!isFetchedTemplates && isErrorTemplates && (
                      <div>Error...</div>
                    )}
                    {categories && (
                      <ActivitySetup
                        workspace={{ workspaceId: workspaceId as string }}
                        allowedLayouts={allowedLayouts}
                        categories={categories}
                        handleUpdateTemplate={handleUpdateCategories}
                      />
                    )}
                  </>
                </Page.Tab>
                <Page.Tab name="Conectores">
                  <>
                    {!isConnectorsFetched && isConnectorsFetching && (
                      <div>Loading...</div>
                    )}
                    {!isConnectorsFetched && isConnectorsError && (
                      <div>Error...</div>
                    )}
                    {connectors && (
                      <ConnectorSetup
                        connectors={connectors}
                        selectedConnectors={selectedConnectors}
                      />
                    )}
                  </>
                </Page.Tab>
                <Page.Tab name="Layouts">
                  <>
                    {!isFetchedLayouts && isFetchingLayouts && (
                      <div>Loading...</div>
                    )}
                    {!isFetchedLayouts && isErrorLayouts && <div>Error...</div>}
                    {layoutsGlobal && (
                      <LayoutSetup
                        layouts={layoutsGlobal}
                        handleUpdateLayouts={handleUpdateLayouts}
                      />
                    )}
                  </>
                </Page.Tab>
              </Page>
            </SetupContext.Provider>
          )}
          {canChange && productData?.product?.name === "Vida" && (
            <LifeSetupContext.Provider
              value={{ setup: lifeSetup, updateSetup: handleSavePolicyAndRulesLife }}
            >
              <Page title="Adicionar um contrato" backRoute={products.link}>
                <Page.Tab name="Dados do contrato">
                  <RulesLife />
                </Page.Tab>
                {/* <Page.Tab name="Dados do contrato">
                  <ContractDataSetup workspace={{ buyerId: productData.buyerId, productId: productData.product.name, sellerId: productData.sellerId, supplierId: productData.supplier.name }} contractData={contractData} handleEdit={handleEditContractData} />
                </Page.Tab> */}
                <Page.Tab name="Negociação">
                  <BenefitsPolicyLife />
                </Page.Tab>
                <Page.Tab name="Capital Segurado + Prêmio">
                  <CapitalInsured />
                </Page.Tab>
                <Page.Tab name="Atividades">
                  <>
                    {!isFetchedTemplates && isFetchingTemplates && (
                      <div>Loading...</div>
                    )}
                    {!isFetchedTemplates && isErrorTemplates && (
                      <div>Error...</div>
                    )}
                    {categories && (
                      <ActivitySetup
                        workspace={{ workspaceId: workspaceId as string }}
                        allowedLayouts={allowedLayouts}
                        categories={categories}
                        handleUpdateTemplate={handleUpdateCategories}
                      />
                    )}
                  </>
                </Page.Tab>
                <Page.Tab name="Conectores">
                  <>
                    {!isConnectorsFetched && isConnectorsFetching && (
                      <div>Loading...</div>
                    )}
                    {!isConnectorsFetched && isConnectorsError && (
                      <div>Error...</div>
                    )}
                    {connectors && (
                      <ConnectorSetup
                        connectors={connectors}
                        selectedConnectors={selectedConnectors}
                      />
                    )}
                  </>
                </Page.Tab>
                <Page.Tab name="Layouts">
                  <>
                    {!isFetchedLayouts && isFetchingLayouts && (
                      <div>Loading...</div>
                    )}
                    {!isFetchedLayouts && isErrorLayouts && <div>Error...</div>}
                    {layoutsGlobal && (
                      <LayoutSetup
                        layouts={layoutsGlobal}
                        handleUpdateLayouts={handleUpdateLayouts}
                      />
                    )}
                  </>
                </Page.Tab>
              </Page>
            </LifeSetupContext.Provider>
          )}
        </>
      )}
    </>
  );
}
